import { useInput } from '../Input';
import { UseInputField } from './types';

const onMouseDown = (event) => event.preventDefault();

export const useInputField: UseInputField = ({ onReset, ...rest }) => {
  const inputProps = useInput(rest);
  const { id, value, disabled, focus, invalid, stateType } = inputProps;
  const stateProps = { disabled, focus, invalid, stateType };
  const isEmpty = value === '';
  const reset = onReset;
  return {
    iconProps: { ...stateProps, isEmpty, reset, onMouseDown },
    inputProps,
    labelProps: { ...stateProps, isEmpty, htmlFor: id },
    fieldProps: stateProps,
    validationProps: { invalid, htmlFor: id },
  };
};
